import type { CallEndToolSettings } from "@repo/app-types/entities/tools/callEnd";
import {
  CallEndToolForm,
  type CallEndToolFormSettings,
} from "../components/callEndToolForm.js";
import type { ToolFormConfig } from "./baseFormConfig.js";

export const callEndToolFormConfig: ToolFormConfig<
  CallEndToolSettings,
  CallEndToolFormSettings
> = {
  initialize: () => ({}),
  validate: () => true,
  save: () => ({ isValid: true, settings: {} }),
  Form: CallEndToolForm,
};
